var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerfil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.7,103.9c0-3.6,3-6.6,6.6-6.6h39.5c3.6,0,6.6,3,6.6,6.6v26.4c0,3.6-3,6.6-6.6,6.6H64.3 c-3.6,0-6.6-3-6.6-6.6V103.9z M136.8,202.7H57.7v-26.4h79.1V202.7z M242.3,202.7h-79.1v-26.4h79.1V202.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.7,103.9c0-3.6,3-6.6,6.6-6.6h39.5c3.6,0,6.6,3,6.6,6.6v26.4c0,3.6-3,6.6-6.6,6.6H64.3 c-3.6,0-6.6-3-6.6-6.6V103.9z M136.8,202.7H57.7v-26.4h79.1V202.7z M242.3,202.7h-79.1v-26.4h79.1V202.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.5,268.6H44.5C22.7,268.6,5,250.9,5,229.1V70.9c0-21.8,17.7-39.5,39.5-39.5h210.9 c21.8,0,39.5,17.7,39.5,39.5v158.2C295,250.9,277.3,268.6,255.5,268.6z M44.5,57.7c-7.3,0-13.2,5.9-13.2,13.2v158.2 c0,7.3,5.9,13.2,13.2,13.2h210.9c7.3,0,13.2-5.9,13.2-13.2V70.9c0-7.3-5.9-13.2-13.2-13.2H44.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfil);
export default __webpack_public_path__ + "static/media/perfil.6472603ee674a7be59a06fa56098f59d.svg";
export { ForwardRef as ReactComponent };